<template>
  <div class="yhc-service-level-notice-row">
    <YhcServiceLevelNotice
      class="yhc-service-level-notice-row__notice"
      :notice-page-key="noticePageKey"
    />
    <div
      class="yhc-service-level-notice-row__action yhc-service-level-notice-row__action--desktop"
    >
      <YhcServiceLevelFeedbackSubmitButton variant="default" />
      <a
        class="yhc-service-level-notice-row__corp-link"
        href="/service-level/corporation"
        target="_blank"
        rel="noopener noreferrer"
      >
        法人向けページはこちら
      </a>
    </div>
    <div
      class="yhc-service-level-notice-row__action yhc-service-level-notice-row__action--mobile"
    >
      <YhcServiceLevelFeedbackSubmitButton variant="compact" />
      <a
        class="yhc-service-level-notice-row__corp-link"
        href="/service-level/corporation"
        target="_blank"
        rel="noopener noreferrer"
      >
        法人向けページはこちら
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import YhcServiceLevelNotice from './YhcServiceLevelNotice.vue'
import YhcServiceLevelFeedbackSubmitButton from './YhcServiceLevelFeedbackSubmitButton.vue'
import type { ServiceLevelNoticePageKey } from '../serviceLevelNoticePageUtils'

export default defineComponent({
  name: 'YhcServiceLevelNoticeRow',
  components: {
    YhcServiceLevelNotice,
    YhcServiceLevelFeedbackSubmitButton,
  },
  props: {
    noticePageKey: {
      type: String as PropType<ServiceLevelNoticePageKey>,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.yhc-service-level-notice-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  margin-bottom: 1rem;
  box-sizing: border-box;

  &__notice {
    flex: 1;
    min-width: 0;
    width: auto !important;
    margin-bottom: 0 !important;
  }

  &__action {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    gap: 8px;
    padding-top: 4px;

    &--mobile {
      display: none;
    }
  }

  &__corp-link {
    font-size: 13px;
    line-height: 1.4;
    white-space: nowrap;
    text-align: right;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;

    &__action--desktop {
      display: none;
    }

    &__action--mobile {
      display: flex;
      width: 50%;
      max-width: 50%;
      align-items: stretch;
      padding-top: 0;

      :deep(.yhc-service-level-feedback-submit-btn) {
        width: 100%;
      }
    }

    &__corp-link {
      font-size: 12px;
      white-space: normal;
      text-align: center;
    }
  }
}
</style>
